import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "./AuthContext";
import { loginPathWithNext } from "./redirect";

const ProtectedRoute = ({ children }) => {
  const { auth } = useContext(AuthContext);
  const location = useLocation();

  if (!auth?.user) {
    return <Navigate to={loginPathWithNext(location.pathname, location.search)} replace />;
  }

  return children;
};

export default ProtectedRoute;
